module.exports = __webpack_public_path__ + "static/media/pla_clear_angel_cut_straw1.de570855.png";